import { useQuery } from '@tanstack/react-query';
import { getStates } from '../services/fn-api/Common';
import { STATES_KEY } from 'src/utils/constants/queryKeys';

export const useGetStates = (country: string) => {
  return useQuery({
    queryKey: [STATES_KEY, country],
    queryFn: () => getStates(country),
    enabled: !!country,
  });
};
